module.exports = __webpack_public_path__ + "static/img/7.452681d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/good-fresh/fresh-images/7.jpg
// module id = IRAc
// module chunks = 1